export const TableMock = () => {
  return (
    <svg
      width="227"
      height="122"
      viewBox="0 0 227 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3975_28034)">
        <rect
          x="1.70117"
          y="0.794922"
          width="224"
          height="120"
          rx="5.53717"
          fill="#F9F7F3"
        />
        <g clipPath="url(#clip1_3975_28034)">
          <mask id="path-3-inside-1_3975_28034" fill="white">
            <path d="M2 16H226V32.1853H2V16Z" />
          </mask>
          <mask id="path-5-inside-2_3975_28034" fill="white">
            <path d="M2 16H21.782V32.1853H2V16Z" />
          </mask>
          <path d="M2 16H21.782V32.1853H2V16Z" fill="#F2F2FD" />
          <path
            d="M21.3296 16V32.1853H22.2344V16H21.3296Z"
            fill="#D7D3C9"
            mask="url(#path-5-inside-2_3975_28034)"
          />
          <mask id="path-7-inside-3_3975_28034" fill="white">
            <path d="M21.782 16H66.741V32.1853H21.782V16Z" />
          </mask>
          <path d="M21.782 16H66.741V32.1853H21.782V16Z" fill="#F2F2FD" />
          <path
            d="M66.2886 16V32.1853H67.1935V16H66.2886Z"
            fill="#D7D3C9"
            mask="url(#path-7-inside-3_3975_28034)"
          />
          <rect
            x="27.177"
            y="21.3945"
            width="19.8232"
            height="5.39509"
            rx="2.69754"
            fill="#DBDBEC"
          />
          <mask id="path-10-inside-4_3975_28034" fill="white">
            <path d="M66.7412 16H111.7V32.1853H66.7412V16Z" />
          </mask>
          <path d="M66.7412 16H111.7V32.1853H66.7412V16Z" fill="#F2F2FD" />
          <path
            d="M111.248 16V32.1853H112.153V16H111.248Z"
            fill="#D7D3C9"
            mask="url(#path-10-inside-4_3975_28034)"
          />
          <rect
            x="72.1362"
            y="21.3945"
            width="23.7455"
            height="5.39509"
            rx="2.69754"
            fill="#DBDBEC"
          />
          <mask id="path-13-inside-5_3975_28034" fill="white">
            <path d="M111.7 16H156.659V32.1853H111.7V16Z" />
          </mask>
          <path d="M111.7 16H156.659V32.1853H111.7V16Z" fill="#F2F2FD" />
          <path
            d="M156.207 16V32.1853H157.112V16H156.207Z"
            fill="#D7D3C9"
            mask="url(#path-13-inside-5_3975_28034)"
          />
          <rect
            x="117.095"
            y="21.3945"
            width="23.7455"
            height="5.39509"
            rx="2.69754"
            fill="#DBDBEC"
          />
          <mask id="path-16-inside-6_3975_28034" fill="white">
            <path d="M156.659 16H201.618V32.1853H156.659V16Z" />
          </mask>
          <path d="M156.659 16H201.618V32.1853H156.659V16Z" fill="#F2F2FD" />
          <path
            d="M201.166 16V32.1853H202.071V16H201.166Z"
            fill="#D7D3C9"
            mask="url(#path-16-inside-6_3975_28034)"
          />
          <path
            d="M165.429 28.4648L169.757 23.3086H167.679V19.6523L163.352 24.8086H165.429V28.4648Z"
            fill="#FF4F00"
          />
          <rect
            x="173.054"
            y="21.3945"
            width="23.6978"
            height="5.39509"
            rx="2.69754"
            fill="#DBDBEC"
          />
          <rect
            width="45"
            height="16"
            transform="translate(201.618 16)"
            fill="#F2F2FD"
          />
          <rect
            x="212.245"
            y="21.3027"
            width="23.7455"
            height="5.39509"
            rx="2.69754"
            fill="#DBDBEC"
          />
        </g>
        <path
          d="M2 16.4524H226V15.5476H2V16.4524ZM226 31.7328H2V32.6377H226V31.7328Z"
          fill="#D7D3C9"
          mask="url(#path-3-inside-1_3975_28034)"
        />
        <g clipPath="url(#clip2_3975_28034)">
          <mask id="path-21-inside-7_3975_28034" fill="white">
            <path d="M2 32.1855H226V48.3708H2V32.1855Z" />
          </mask>
          <mask id="path-23-inside-8_3975_28034" fill="white">
            <path d="M2 32.1855H21.782V48.3708H2V32.1855Z" />
          </mask>
          <path d="M2 32.1855H21.782V48.3708H2V32.1855Z" fill="#FFFDF9" />
          <path
            d="M21.3296 32.1855V48.3708H22.2344V32.1855H21.3296Z"
            fill="#D7D3C9"
            mask="url(#path-23-inside-8_3975_28034)"
          />
          <rect
            x="9.1936"
            y="37.582"
            width="5.39509"
            height="5.39509"
            fill="#FFFDF9"
          />
          <path
            d="M8.51978 43.6501H15.2636V36.9062H8.51978V43.6501ZM9.26909 37.6556H14.5143V42.9008H9.26909V37.6556Z"
            fill="#D7D3C9"
          />
          <mask id="path-27-inside-9_3975_28034" fill="white">
            <path d="M21.7817 32.1855H66.7408V48.3708H21.7817V32.1855Z" />
          </mask>
          <path
            d="M21.7817 32.1855H66.7408V48.3708H21.7817V32.1855Z"
            fill="#FFFDF9"
          />
          <path
            d="M66.2884 32.1855V48.3708H67.1932V32.1855H66.2884Z"
            fill="#D7D3C9"
            mask="url(#path-27-inside-9_3975_28034)"
          />
          <rect
            x="27.177"
            y="37.5801"
            width="31.873"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-30-inside-10_3975_28034" fill="white">
            <path d="M66.7412 32.1855H111.7V48.3708H66.7412V32.1855Z" />
          </mask>
          <path
            d="M66.7412 32.1855H111.7V48.3708H66.7412V32.1855Z"
            fill="#FFFDF9"
          />
          <path
            d="M111.248 32.1855V48.3708H112.153V32.1855H111.248Z"
            fill="#D7D3C9"
            mask="url(#path-30-inside-10_3975_28034)"
          />
          <rect
            x="72.1362"
            y="37.5801"
            width="18.0618"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-33-inside-11_3975_28034" fill="white">
            <path d="M111.7 32.1855H156.659V48.3708H111.7V32.1855Z" />
          </mask>
          <path
            d="M111.7 32.1855H156.659V48.3708H111.7V32.1855Z"
            fill="#FFFDF9"
          />
          <path
            d="M156.207 32.1855V48.3708H157.112V32.1855H156.207Z"
            fill="#D7D3C9"
            mask="url(#path-33-inside-11_3975_28034)"
          />
          <rect
            x="117.095"
            y="37.5801"
            width="18.0618"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-36-inside-12_3975_28034" fill="white">
            <path d="M156.659 32.1855H201.618V48.3708H156.659V32.1855Z" />
          </mask>
          <path
            d="M156.659 32.1855H201.618V48.3708H156.659V32.1855Z"
            fill="#FFFDF9"
          />
          <path
            d="M201.166 32.1855V48.3708H202.071V32.1855H201.166Z"
            fill="#D7D3C9"
            mask="url(#path-36-inside-12_3975_28034)"
          />
          <rect
            x="162.054"
            y="37.5801"
            width="18.0618"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-39-inside-13_3975_28034" fill="white">
            <path d="M201.618 32.1855H246.577V48.3708H201.618V32.1855Z" />
          </mask>
          <path
            d="M201.618 32.1855H246.577V48.3708H201.618V32.1855Z"
            fill="#FFFDF9"
          />
          <path
            d="M246.125 32.1855V48.3708H247.03V32.1855H246.125Z"
            fill="#D7D3C9"
            mask="url(#path-39-inside-13_3975_28034)"
          />
          <rect
            x="207.013"
            y="37.5801"
            width="18.0618"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M226 47.9184H2V48.8232H226V47.9184Z"
          fill="#D7D3C9"
          mask="url(#path-21-inside-7_3975_28034)"
        />
        <g clipPath="url(#clip3_3975_28034)">
          <mask id="path-42-inside-14_3975_28034" fill="white">
            <path d="M2 48.3711H226V64.5564H2V48.3711Z" />
          </mask>
          <mask id="path-44-inside-15_3975_28034" fill="white">
            <path d="M2 48.3711H21.782V64.5564H2V48.3711Z" />
          </mask>
          <path d="M2 48.3711H21.782V64.5564H2V48.3711Z" fill="#FFFDF9" />
          <path
            d="M21.3296 48.3711V64.5564H22.2344V48.3711H21.3296Z"
            fill="#D7D3C9"
            mask="url(#path-44-inside-15_3975_28034)"
          />
          <rect
            x="9.1936"
            y="53.7676"
            width="5.39509"
            height="5.39509"
            fill="#FFFDF9"
          />
          <path
            d="M8.51978 59.8357H15.2636V53.0918H8.51978V59.8357ZM9.26909 53.8411H14.5143V59.0863H9.26909V53.8411Z"
            fill="#D7D3C9"
          />
          <mask id="path-48-inside-16_3975_28034" fill="white">
            <path d="M21.7817 48.3711H66.7408V64.5564H21.7817V48.3711Z" />
          </mask>
          <path
            d="M21.7817 48.3711H66.7408V64.5564H21.7817V48.3711Z"
            fill="#FFFDF9"
          />
          <path
            d="M66.2884 48.3711V64.5564H67.1932V48.3711H66.2884Z"
            fill="#D7D3C9"
            mask="url(#path-48-inside-16_3975_28034)"
          />
          <rect
            x="27.177"
            y="53.7656"
            width="27.3261"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-51-inside-17_3975_28034" fill="white">
            <path d="M66.7412 48.3711H111.7V64.5564H66.7412V48.3711Z" />
          </mask>
          <path
            d="M66.7412 48.3711H111.7V64.5564H66.7412V48.3711Z"
            fill="#FFFDF9"
          />
          <path
            d="M111.248 48.3711V64.5564H112.153V48.3711H111.248Z"
            fill="#D7D3C9"
            mask="url(#path-51-inside-17_3975_28034)"
          />
          <rect
            x="72.1362"
            y="53.7656"
            width="28.52"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-54-inside-18_3975_28034" fill="white">
            <path d="M111.7 48.3711H156.659V64.5564H111.7V48.3711Z" />
          </mask>
          <path
            d="M111.7 48.3711H156.659V64.5564H111.7V48.3711Z"
            fill="#FFFDF9"
          />
          <path
            d="M156.207 48.3711V64.5564H157.112V48.3711H156.207Z"
            fill="#D7D3C9"
            mask="url(#path-54-inside-18_3975_28034)"
          />
          <rect
            x="117.095"
            y="53.7656"
            width="28.52"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-57-inside-19_3975_28034" fill="white">
            <path d="M156.659 48.3711H201.618V64.5564H156.659V48.3711Z" />
          </mask>
          <path
            d="M156.659 48.3711H201.618V64.5564H156.659V48.3711Z"
            fill="#FFFDF9"
          />
          <path
            d="M201.166 48.3711V64.5564H202.071V48.3711H201.166Z"
            fill="#D7D3C9"
            mask="url(#path-57-inside-19_3975_28034)"
          />
          <rect
            x="162.054"
            y="53.7656"
            width="28.52"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-60-inside-20_3975_28034" fill="white">
            <path d="M201.618 48.3711H246.577V64.5564H201.618V48.3711Z" />
          </mask>
          <path
            d="M201.618 48.3711H246.577V64.5564H201.618V48.3711Z"
            fill="#FFFDF9"
          />
          <path
            d="M246.125 48.3711V64.5564H247.03V48.3711H246.125Z"
            fill="#D7D3C9"
            mask="url(#path-60-inside-20_3975_28034)"
          />
          <rect
            x="207.013"
            y="53.7656"
            width="28.52"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M226 64.1039H2V65.0088H226V64.1039Z"
          fill="#D7D3C9"
          mask="url(#path-42-inside-14_3975_28034)"
        />
        <g clipPath="url(#clip4_3975_28034)">
          <mask id="path-63-inside-21_3975_28034" fill="white">
            <path d="M2 64.5566H226V80.7419H2V64.5566Z" />
          </mask>
          <mask id="path-65-inside-22_3975_28034" fill="white">
            <path d="M2 64.5566H21.782V80.7419H2V64.5566Z" />
          </mask>
          <path d="M2 64.5566H21.782V80.7419H2V64.5566Z" fill="#FFFDF9" />
          <path
            d="M21.3296 64.5566V80.7419H22.2344V64.5566H21.3296Z"
            fill="#D7D3C9"
            mask="url(#path-65-inside-22_3975_28034)"
          />
          <rect
            x="9.1936"
            y="69.9531"
            width="5.39509"
            height="5.39509"
            fill="#FFFDF9"
          />
          <path
            d="M8.51978 76.0212H15.2636V69.2773H8.51978V76.0212ZM9.26909 70.0267H14.5143V75.2719H9.26909V70.0267Z"
            fill="#D7D3C9"
          />
          <mask id="path-69-inside-23_3975_28034" fill="white">
            <path d="M21.7817 64.5566H66.7408V80.7419H21.7817V64.5566Z" />
          </mask>
          <path
            d="M21.7817 64.5566H66.7408V80.7419H21.7817V64.5566Z"
            fill="#FFFDF9"
          />
          <path
            d="M66.2884 64.5566V80.7419H67.1932V64.5566H66.2884Z"
            fill="#D7D3C9"
            mask="url(#path-69-inside-23_3975_28034)"
          />
          <rect
            x="27.177"
            y="69.9512"
            width="30.5089"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-72-inside-24_3975_28034" fill="white">
            <path d="M66.7412 64.5566H111.7V80.7419H66.7412V64.5566Z" />
          </mask>
          <path
            d="M66.7412 64.5566H111.7V80.7419H66.7412V64.5566Z"
            fill="#FFFDF9"
          />
          <path
            d="M111.248 64.5566V80.7419H112.153V64.5566H111.248Z"
            fill="#D7D3C9"
            mask="url(#path-72-inside-24_3975_28034)"
          />
          <rect
            x="72.1362"
            y="69.9512"
            width="19.653"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-75-inside-25_3975_28034" fill="white">
            <path d="M111.7 64.5566H156.659V80.7419H111.7V64.5566Z" />
          </mask>
          <path
            d="M111.7 64.5566H156.659V80.7419H111.7V64.5566Z"
            fill="#FFFDF9"
          />
          <path
            d="M156.207 64.5566V80.7419H157.112V64.5566H156.207Z"
            fill="#D7D3C9"
            mask="url(#path-75-inside-25_3975_28034)"
          />
          <rect
            x="117.095"
            y="69.9512"
            width="19.653"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-78-inside-26_3975_28034" fill="white">
            <path d="M156.659 64.5566H201.618V80.7419H156.659V64.5566Z" />
          </mask>
          <path
            d="M156.659 64.5566H201.618V80.7419H156.659V64.5566Z"
            fill="#FFFDF9"
          />
          <path
            d="M201.166 64.5566V80.7419H202.071V64.5566H201.166Z"
            fill="#D7D3C9"
            mask="url(#path-78-inside-26_3975_28034)"
          />
          <rect
            x="162.054"
            y="69.9512"
            width="19.653"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <rect
            width="44.9591"
            height="16.1853"
            transform="translate(201.618 64.5566)"
            fill="#FFFDF9"
          />
          <rect
            x="207.013"
            y="69.9512"
            width="25.1771"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M226 80.2895H2V81.1943H226V80.2895Z"
          fill="#D7D3C9"
          mask="url(#path-63-inside-21_3975_28034)"
        />
        <g clipPath="url(#clip5_3975_28034)">
          <mask id="path-82-inside-27_3975_28034" fill="white">
            <path d="M2 80.7402H226V96.9255H2V80.7402Z" />
          </mask>
          <mask id="path-84-inside-28_3975_28034" fill="white">
            <path d="M2 80.7402H21.782V96.9255H2V80.7402Z" />
          </mask>
          <path d="M2 80.7402H21.782V96.9255H2V80.7402Z" fill="#FFFDF9" />
          <path
            d="M21.3296 80.7402V96.9255H22.2344V80.7402H21.3296Z"
            fill="#D7D3C9"
            mask="url(#path-84-inside-28_3975_28034)"
          />
          <rect
            x="9.1936"
            y="86.1367"
            width="5.39509"
            height="5.39509"
            fill="#FFFDF9"
          />
          <path
            d="M8.51978 92.2048H15.2636V85.4609H8.51978V92.2048ZM9.26909 86.2103H14.5143V91.4555H9.26909V86.2103Z"
            fill="#D7D3C9"
          />
          <mask id="path-88-inside-29_3975_28034" fill="white">
            <path d="M21.782 80.7402H66.741V96.9255H21.782V80.7402Z" />
          </mask>
          <path
            d="M21.782 80.7402H66.741V96.9255H21.782V80.7402Z"
            fill="#FFFDF9"
          />
          <path
            d="M66.2886 80.7402V96.9255H67.1935V80.7402H66.2886Z"
            fill="#D7D3C9"
            mask="url(#path-88-inside-29_3975_28034)"
          />
          <rect
            x="27.1772"
            y="86.1348"
            width="23.0063"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-91-inside-30_3975_28034" fill="white">
            <path d="M66.7412 80.7402H111.7V96.9255H66.7412V80.7402Z" />
          </mask>
          <path
            d="M66.7412 80.7402H111.7V96.9255H66.7412V80.7402Z"
            fill="#FFFDF9"
          />
          <path
            d="M111.248 80.7402V96.9255H112.153V80.7402H111.248Z"
            fill="#D7D3C9"
            mask="url(#path-91-inside-30_3975_28034)"
          />
          <rect
            x="72.1362"
            y="86.1348"
            width="20.5624"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-94-inside-31_3975_28034" fill="white">
            <path d="M111.7 80.7402H156.659V96.9255H111.7V80.7402Z" />
          </mask>
          <path
            d="M111.7 80.7402H156.659V96.9255H111.7V80.7402Z"
            fill="#FFFDF9"
          />
          <path
            d="M156.207 80.7402V96.9255H157.112V80.7402H156.207Z"
            fill="#D7D3C9"
            mask="url(#path-94-inside-31_3975_28034)"
          />
          <rect
            x="117.095"
            y="86.1348"
            width="20.5624"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-97-inside-32_3975_28034" fill="white">
            <path d="M156.659 80.7402H201.618V96.9255H156.659V80.7402Z" />
          </mask>
          <path
            d="M156.659 80.7402H201.618V96.9255H156.659V80.7402Z"
            fill="#FFFDF9"
          />
          <path
            d="M201.166 80.7402V96.9255H202.071V80.7402H201.166Z"
            fill="#D7D3C9"
            mask="url(#path-97-inside-32_3975_28034)"
          />
          <rect
            x="162.054"
            y="86.1348"
            width="20.5624"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <rect
            width="44.9591"
            height="16.1853"
            transform="translate(201.618 80.7402)"
            fill="#FFFDF9"
          />
          <rect
            x="207.013"
            y="86.1348"
            width="25.1771"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M226 96.4731H2V97.3779H226V96.4731Z"
          fill="#D7D3C9"
          mask="url(#path-82-inside-27_3975_28034)"
        />
        <g clipPath="url(#clip6_3975_28034)">
          <mask id="path-101-inside-33_3975_28034" fill="white">
            <path d="M2 96.9258H226V113.111H2V96.9258Z" />
          </mask>
          <mask id="path-103-inside-34_3975_28034" fill="white">
            <path d="M2 96.9258H21.782V113.111H2V96.9258Z" />
          </mask>
          <path d="M2 96.9258H21.782V113.111H2V96.9258Z" fill="#FFFDF9" />
          <path
            d="M21.3296 96.9258V113.111H22.2344V96.9258H21.3296Z"
            fill="#D7D3C9"
            mask="url(#path-103-inside-34_3975_28034)"
          />
          <rect
            x="9.1936"
            y="102.322"
            width="5.39509"
            height="5.39509"
            fill="#FFFDF9"
          />
          <path
            d="M8.51978 108.39H15.2636V101.646H8.51978V108.39ZM9.26909 102.396H14.5143V107.641H9.26909V102.396Z"
            fill="#D7D3C9"
          />
          <mask id="path-107-inside-35_3975_28034" fill="white">
            <path d="M21.7817 96.9258H66.7408V113.111H21.7817V96.9258Z" />
          </mask>
          <path
            d="M21.7817 96.9258H66.7408V113.111H21.7817V96.9258Z"
            fill="#FFFDF9"
          />
          <path
            d="M66.2884 96.9258V113.111H67.1932V96.9258H66.2884Z"
            fill="#D7D3C9"
            mask="url(#path-107-inside-35_3975_28034)"
          />
          <rect
            x="27.177"
            y="102.32"
            width="32.5551"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-110-inside-36_3975_28034" fill="white">
            <path d="M66.7412 96.9258H111.7V113.111H66.7412V96.9258Z" />
          </mask>
          <path
            d="M66.7412 96.9258H111.7V113.111H66.7412V96.9258Z"
            fill="#FFFDF9"
          />
          <path
            d="M111.248 96.9258V113.111H112.153V96.9258H111.248Z"
            fill="#D7D3C9"
            mask="url(#path-110-inside-36_3975_28034)"
          />
          <rect
            x="72.1362"
            y="102.32"
            width="23.2907"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-113-inside-37_3975_28034" fill="white">
            <path d="M111.7 96.9258H156.659V113.111H111.7V96.9258Z" />
          </mask>
          <path
            d="M111.7 96.9258H156.659V113.111H111.7V96.9258Z"
            fill="#FFFDF9"
          />
          <path
            d="M156.207 96.9258V113.111H157.112V96.9258H156.207Z"
            fill="#D7D3C9"
            mask="url(#path-113-inside-37_3975_28034)"
          />
          <rect
            x="117.095"
            y="102.32"
            width="23.2907"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <mask id="path-116-inside-38_3975_28034" fill="white">
            <path d="M156.659 96.9258H201.618V113.111H156.659V96.9258Z" />
          </mask>
          <path
            d="M156.659 96.9258H201.618V113.111H156.659V96.9258Z"
            fill="#FFFDF9"
          />
          <path
            d="M201.166 96.9258V113.111H202.071V96.9258H201.166Z"
            fill="#D7D3C9"
            mask="url(#path-116-inside-38_3975_28034)"
          />
          <rect
            x="162.054"
            y="102.32"
            width="23.2907"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
          <rect
            width="44.9591"
            height="16.1853"
            transform="translate(201.618 96.9258)"
            fill="#FFFDF9"
          />
          <rect
            x="207.013"
            y="102.32"
            width="25.1771"
            height="5.39509"
            rx="2.69754"
            fill="#F5F3EB"
          />
        </g>
        <path
          d="M226 112.659H2V113.563H226V112.659Z"
          fill="#D7D3C9"
          mask="url(#path-101-inside-33_3975_28034)"
        />
        <path
          d="M9.36011 6.52734H13.8262V7.16536H9.36011V6.52734Z"
          fill="#B5B2AA"
        />
        <path
          d="M9.36011 7.80337H12.1514V8.44139H9.36011V7.80337Z"
          fill="#B5B2AA"
        />
        <path
          d="M12.1514 10.3554H9.36011V10.9935H12.1514V10.3554Z"
          fill="#B5B2AA"
        />
        <path
          d="M9.36011 9.07941H13.8262V9.71742H9.36011V9.07941Z"
          fill="#B5B2AA"
        />
      </g>
      <rect
        x="1.34117"
        y="0.434922"
        width="224.72"
        height="120.72"
        rx="5.89717"
        stroke="#B5B2AA"
        strokeWidth="0.72"
      />
      <defs>
        <clipPath id="clip0_3975_28034">
          <rect
            x="1.70117"
            y="0.794922"
            width="224"
            height="120"
            rx="5.53717"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_3975_28034">
          <path d="M2 16H226V32.1853H2V16Z" fill="white" />
        </clipPath>
        <clipPath id="clip2_3975_28034">
          <path d="M2 32.1855H226V48.3708H2V32.1855Z" fill="white" />
        </clipPath>
        <clipPath id="clip3_3975_28034">
          <path d="M2 48.3711H226V64.5564H2V48.3711Z" fill="white" />
        </clipPath>
        <clipPath id="clip4_3975_28034">
          <path d="M2 64.5566H226V80.7419H2V64.5566Z" fill="white" />
        </clipPath>
        <clipPath id="clip5_3975_28034">
          <path d="M2 80.7402H226V96.9255H2V80.7402Z" fill="white" />
        </clipPath>
        <clipPath id="clip6_3975_28034">
          <path d="M2 96.9258H226V113.111H2V96.9258Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
